import type { SponsorFeature } from '../../services/collection-service';

/** Fiction-native sponsor panel, styled as the gold feature card (mockup
 * #5c/#7a "BEAN OF THE WEEK" treatment). Hard rule: renders NOTHING without
 * an active sponsorship, and always carries the SPONSORED tag when it does. */
export default function BeanOfTheWeek({ feature }: { feature: SponsorFeature | null }) {
  if (!feature) return null;
  return (
    <div className="bg-accent-alt pixel-corners p-5">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <p className="font-heading text-[8px] text-gold-ink tracking-[1px]">BEAN OF THE WEEK</p>
        <span className="font-heading text-[8px] text-gold-ink/70 uppercase">
          SPONSORED · {feature.sponsor_name}
        </span>
      </div>
      <p className="font-grotesk font-bold text-2xl text-primary mb-2">{feature.bean_name}</p>
      {feature.tasting_notes.length > 0 && (
        <div className="flex gap-2 mb-4 flex-wrap">
          {feature.tasting_notes.map(n => (
            <span key={n} className="font-grotesk font-medium text-[14px] text-gold-ink">{n}</span>
          ))}
        </div>
      )}
      {feature.website && (
        <a href={feature.website} target="_blank" rel="noopener noreferrer"
          className="inline-block pixel-corners-sm bg-white text-primary font-grotesk font-bold text-[13px] px-4 py-2 mt-1">
          {feature.link_label}
        </a>
      )}
    </div>
  );
}
